import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { UserInfoService } from '../user-info/user-info.service';
import { RoutingEntity } from './routing-center.interface';

@Injectable()
export class RoutingCenterService {

    private routingMap: Array<RoutingEntity> = [
        {
            path: 'admin',
            name: '后台管理',
            authority: 'admin',
            notLink: true,
            subRouting: [
                {
                    path: 'mentalseal',
                    notLink: true,
                    name: '系统管理',
                    appIconClass: 'fa-gear',
                    app: 'mentalseal',
                    subRouting: [
                        {
                            path: 'app-list',
                            name: 'APP管理',
                            iconClass: 'test2',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'edit',
                                    name: '编辑'
                                },
                                {
                                    path: 'new',
                                    name: '新建'
                                }
                            ]
                        },
                        {
                            path: 'admin-list',
                            name: '用户管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'edit',
                                    name: '编辑'
                                },
                                {
                                    path: 'new',
                                    name: '新建'
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'launcher',
                    notLink: true,
                    name: 'APP启动页',
                    appIconClass: 'fa-image',
                    app: 'app-launcher',
                    subRouting: [
                        {
                            path: 'list',
                            name: 'APP列表',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'update',
                                    name: '编辑'
                                },
                                {
                                    path: 'add',
                                    name: '新建'
                                }
                            ]
                        },
                        {
                            path: 'edit',
                            name: '管理'
                        }
                    ]
                },
                {
                    path: 'warpdriver',
                    notLink: true,
                    name: '商品审核系统',
                    appIconClass: 'fa-gg-circle',
                    app: 'production-audit-manage',
                    subRouting: [
                        {
                            path: 'operation-list',
                            name: '商品审核',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'detail',
                                    name: '详情'
                                },
                                {
                                    path: 'check',
                                    name: '审核',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'service-manage',
                            name: '服务步骤管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'editor',
                    notLink: true,
                    name: '编辑器',
                    appIconClass: 'fa-cutlery',
                    app: 'edit-manage',
                    subRouting: [
                        {
                            path: 'editor-manage',
                            name: '编辑管理',
                            inMenu: true
                        }
                    ]
                },
                {
                    path: 'swordkeeper',
                    notLink: true,
                    name: '订单管理',
                    appIconClass: 'fa-indent',
                    app: 'swordkeeper',
                    subRouting: [
                        {
                            path: 'order-list',
                            name: '订单列表',
                            inMenu: true,
                            subRouting: []
                        }
                    ]
                }, { //张小晴新增 统计分析
                    path: 'statistical-analysis',
                    notLink: true,
                    name: '卫健委统计',
                    appIconClass: 'fa-indent',
                    app: 'statistical-analysis',
                    subRouting: [
                        {
                            path: 'nursing-rankings',
                            name: '机构排行榜',
                            inMenu: true,
                            subRouting: []
                        },
                        {
                            path: 'platform',
                            name: '平台信息统计',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'platform-list',
                                    name: '排行统计'
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'organization',
                    notLink: true,
                    name: '销售化管理',
                    app: 'sell-manage',
                    appIconClass: 'fa-dropbox',
                    subRouting: [
                        {
                            path: 'organization-manage',
                            name: '机构列表',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'content',
                    notLink: true,
                    name: '内容集管理',
                    appIconClass: 'fa-database',
                    app: 'content-manage',
                    subRouting: [
                        {
                            path: 'department-content-manage',
                            name: '科室内容管理',
                            inMenu: true
                        },
                        {
                            path: 'article-manage',
                            name: '宣教管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'tool-manage',
                            name: '自测管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'eva-manage',
                            name: '评估管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'scale-manage',
                            name: '量表管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'hf-echarts',
                    name: '患者出院数据',
                    notLink: true,
                    app: 'hf-echarts',
                    appIconClass: 'fa-area-chart',
                    subRouting: [
                        {
                            path: 'basic-quota',
                            name: '基础指标',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'info',
                                    name: '病区详情',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'relate-quota',
                            name: '关联指标',
                            inMenu: true
                        },
                        {
                            path: 'patient-list',
                            name: '患者列表',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'info',
                                    name: '患者详情',
                                    notLink: true
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'goods-publish',
                    notLink: true,
                    name: '商品发布系统',
                    appIconClass: 'fa-gg-circle',
                    app: 'production-publish-manage',
                    subRouting: [
                        {
                            path: 'goods-category',
                            name: '类型列表',
                            inMenu: true,
                            subRouting: []
                        },
                        {
                            path: 'goods-icon',
                            name: '商品图片列表',
                            inMenu: true,
                            subRouting: []
                        },
                        {
                            path: 'goods-list',
                            name: '商品列表',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'new',
                                    name: '新建'
                                },
                                {
                                    path: 'edit',
                                    name: '编辑',
                                    notLink: true,
                                    subRouting: [
                                        {
                                            path: 'basic',
                                            name: '基础信息'
                                        },
                                        {
                                            path: 'service',
                                            name: '服务信息设置'
                                        }
                                    ]
                                },
                                {
                                    path: 'detail',
                                    name: '套餐详情'
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'resource',
                    notLink: true,
                    name: '资源管理',
                    appIconClass: 'fa-cog',
                    app: 'resource-manage',
                    subRouting: [
                        {
                            path: 'mainpage',
                            name: '主页',
                            inMenu: true
                        },
                        {
                            path: 'homepage',
                            name: '首页管理',
                            inMenu: true
                        },
                        {
                            path: 'article-manage',
                            name: '宣教管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'tool-manage',
                            name: '自测管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                }
                            ]
                        },
                        {
                            path: 'evaluation-manage',
                            name: '评估管理',
                            inMenu: true,
                            subRouting: []
                        },
                        {
                            path: 'service-manage',
                            name: '服务管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'new',
                                    name: '新建'
                                },
                                {
                                    path: 'edit',
                                    name: '编辑',
                                    subRouting: [
                                        {
                                            path: 'basic',
                                            name: '基础信息'
                                        },
                                        {
                                            path: 'service',
                                            name: '服务信息设置'
                                        }
                                    ]
                                }
                                // {
                                //     path: 'new',
                                //     name: '新建'
                                // },
                                // {
                                //     path: 'edit',
                                //     name: '编辑'
                                // }
                                // {
                                //   path: 'check',
                                //   name: '审核'
                                // }
                            ]
                        },
                        // {
                        //   path: 'nurse-manage',
                        //   name: '医护人员管理',
                        //   inMenu: true,
                        //   subRouting: [
                        //     {
                        //       path: 'add',
                        //       name: '新建'
                        //     },
                        //     {
                        //       path: 'update',
                        //       name: '编辑',
                        //       notLink: true
                        //     },
                        //     {
                        //       path: 'service',
                        //       name: '服务'
                        //     },
                        //     {
                        //       path: 'record',
                        //       name: '随访记录'
                        //     },
                        //     {
                        //       path: 'followup',
                        //       name: '随访管理',
                        //       subRouting: [
                        //         {
                        //           path: 'add',
                        //           name: '新建'
                        //         }
                        //       ]
                        //     },
                        //     {
                        //       path: 'evaluation',
                        //       name: '评估管理',
                        //       subRouting: [
                        //         {
                        //           path: 'add',
                        //           name: '新建'
                        //         }
                        //       ]
                        //     }
                        //   ]
                        // },
                        {
                            path: 'notice-manage',
                            name: '公告管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'scheduling-manage',
                            name: '排班管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'nurse-order-manage',
                            name: '工单管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'followup',
                                    name: '随访管理',
                                    notLink: true,
                                    subRouting: [
                                        {
                                            path: 'add',
                                            name: '新建'
                                        },
                                        {
                                            path: 'update',
                                            name: '编辑'
                                        }
                                    ]
                                },
                                {
                                    path: 'evaluation',
                                    name: '评估管理',
                                    notLink: true,
                                    subRouting: [
                                        {
                                            path: 'add',
                                            name: '新建'
                                        },
                                        {
                                            path: 'update',
                                            name: '编辑'
                                        },
                                        {
                                            path: 'record',
                                            name: '详情'
                                        }
                                    ]
                                }
                            ]
                        },

                    ]
                },
                {
                    path: 'patient',
                    notLink: true,
                    name: '患者管理',
                    app: 'patient-manage',
                    appIconClass: 'fa-users',
                    subRouting: [
                        {
                            path: 'patient-manage',
                            name: '患者列表',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                },
                                {
                                    path: 'in-file',
                                    name: '归档患者列表'
                                },
                                {
                                    path: 'batch-tags',
                                    name: '批量加标签'
                                },
                                {
                                    path: 'batch-followup',
                                    name: '创建随访'
                                },
                                {
                                    path: 'batch-evaluation',
                                    name: '创建评估'
                                },
                                {
                                    path: 'batch-article',
                                    name: '推送宣教'
                                },
                                {
                                    path: 'batch-tool',
                                    name: '推送自测'
                                }
                            ]
                        },
                        {
                            path: 'tag-manage',
                            name: '标签管理',
                            inMenu: true
                        },
                        {
                            path: 'follow-up-manage',
                            name: '随访管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'follow-up',
                                    name: '随访管理',
                                    notLink: true,
                                    subRouting: [
                                        {
                                            path: 'add',
                                            name: '新建'
                                        },
                                        {
                                            path: 'update',
                                            name: '编辑',
                                            notLink: true
                                        }
                                    ]
                                },
                                {
                                    path: 'care-path',
                                    name: '评估管理',
                                    notLink: true,
                                    subRouting: [
                                        {
                                            path: 'add',
                                            name: '新建'
                                        },
                                        {
                                            path: 'update',
                                            name: '编辑',
                                            notLink: true
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'advice',
                            name: '意见反馈',
                            inMenu: true
                        },
                        // {
                        //   path: 'platform-evaluation',
                        //   name: '平台评价',
                        //   inMenu: true
                        // },
                        {
                            path: 'complaint',
                            name: '投诉处理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'info',
                                    name: '投诉详情',
                                    notLink: true
                                },
                            ]
                        },
                    ]
                },

                {
                    path: 'scientific',
                    notLink: true,
                    name: '科研管理',
                    appIconClass: 'fa-gears',
                    app: 'scientific-manage',
                    subRouting: [
                        {
                            path: 'research-manage',
                            name: '科研项目',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                },
                                {
                                    path: 'relateInfo',
                                    name: '内容关联',
                                    notLink: true
                                },
                                {
                                    path: 'group',
                                    name: '分组',
                                    notLink: true,
                                    subRouting: [
                                        {
                                            path: 'patient-manage',
                                            name: '患者管理'
                                        },
                                        {
                                            path: 'nurses-manage',
                                            name: '患者管理'
                                        },
                                        {
                                            path: 'add',
                                            name: '新建分组'
                                        }
                                    ]
                                }
                            ]
                        },
                    ]
                },
                // 保单管理
                {
                    path: 'guarantee',
                    notLink: true,
                    name: '保单管理',
                    appIconClass: 'fa-gears',
                    app: 'guarantee-manage',
                    subRouting: [
                        {
                            path: 'guarantee-slip-manage',
                            name: '保单列表',
                            inMenu: true,
                            subRouting: []
                        },
                    ]
                },
                // 系统分析
                {
                    path: 'statistical',
                    notLink: true,
                    name: '统计分析',
                    appIconClass: 'fa-gears',
                    app: 'statistical-manage',
                    subRouting: [
                        {
                            path: 'statistical',
                            name: '系统分析',
                            inMenu: true,
                            subRouting: []
                        }
                    ]
                },
                // 评价管理
                {
                    path: 'evaluation',
                    notLink: true,
                    name: '评价管理',
                    appIconClass: 'fa-gears',
                    app: 'evaluation',
                    subRouting: [
                        {
                            path: 'evaluation-list',
                            name: '评价列表',
                            inMenu: true,
                            subRouting: []
                        }
                    ]
                },
                {
                    path: 'consumable',
                    notLink: true,
                    name: '耗材管理',
                    appIconClass: 'fa-gears',
                    app: 'consumable-manage',
                    subRouting: [
                        {
                            path: 'item-list',
                            name: '耗材单项管理',
                            inMenu: true,
                            subRouting: [

                            ]
                        },
                        {
                            path: 'package-list',
                            name: '耗材包管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'info',
                                    name: '耗材包详情',
                                    notLink: true
                                },
                            ]
                        }, {
                            path: 'receive',
                            name: '耗材领取记录',
                            inMenu: true,
                            subRouting: []
                        }
                    ]
                },
                {
                    path: 'mentality',
                    notLink: true,
                    name: '心理咨询',
                    appIconClass: 'fa-gears',
                    app: 'mentality-manage',
                    subRouting: [
                        {
                            path: 'recovery',
                            name: '康复咨询',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'scale-info',
                                    name: '量表详情',
                                    notLink: true
                                },
                                {
                                    path: 'scale-list',
                                    name: '量表列表',
                                    notLink: true
                                }
                            ]
                        },
                        // {
                        //   path: 'secret',
                        //   name: '秘密',
                        //   inMenu: true,
                        //   subRouting: [

                        //   ]
                        // },
                        {
                            path: 'treehole',
                            name: '思念树洞',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'info',
                                    name: '树洞详情',
                                    notLink: true
                                },
                            ]
                        }
                    ]
                },
                {
                    path: 'worker',
                    notLink: true,
                    name: '医护人员管理',
                    app: 'worker-manage',
                    appIconClass: 'fa-gears',
                    subRouting: [
                        {
                            path: 'worker-list',
                            name: '医护人员列表',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'info',
                                    name: '详情'
                                },
                            ]
                        },
                        {
                            path: 'worker-register',
                            name: '医护人员注册',
                            inMenu: true,
                            subRouting: [

                            ]
                        }
                    ]
                },
                {
                    path: 'family',
                    notLink: true,
                    name: '家医签约管理',
                    appIconClass: 'fa-gears',
                    app: 'family-manage',
                    subRouting: [
                        {
                            path: 'family-manage',
                            name: '家医签约列表',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                },
                            ]
                        }
                    ]
                },
                {
                    path: 'monitor',
                    notLink: true,
                    name: '病房监控管理',
                    appIconClass: 'fa-video-camera',
                    app: 'monitor-manage',
                    subRouting: [
                        {
                            path: 'monitor-manage',
                            name: '摄像头绑定管理',
                            inMenu: true
                        },
                        {
                            path: 'monitor-time',
                            name: '监控时段管理',
                            inMenu: true
                        }
                    ]
                },
                {
                    path: 'owner-organization',
                    notLink: true,
                    name: '机构管理',
                    app: 'organization-manage',
                    appIconClass: 'fa-dropbox',
                    subRouting: [
                        {
                            path: 'organization-manage',
                            name: '机构列表',
                            inMenu: true,
                            subRouting: [
                                // {
                                //   path: 'update',
                                //   name: '编辑',
                                //   notLink: true
                                // }
                            ]
                        },
                        {
                            path: 'administrative-manage',
                            name: '科室列表',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        }
                    ]
                },

                {
                    path: 'orders-v2',
                    name: '照护订单管理',
                    notLink: true,
                    app: 'CAT',
                    appIconClass: 'fa-clipboard',
                    subRouting: [
                        {
                            path: 'order-manage',
                            name: '订单列表',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'new',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true,
                                    subRouting: [
                                        {
                                            path: 'evaInfo',
                                            name: '评估详情'
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'personnel',
                    name: '人员管理',
                    notLink: true,
                    app: 'CAT',
                    appIconClass: 'fa-users',
                    subRouting: [
                        {
                            path: 'owner-manage',
                            name: '管理员管理',
                            appSubRole: ['测试', '管理员'],
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建管理员'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'user-manage',
                            name: '用户管理',
                            inMenu: true,
                            appSubRole: ['测试', '管理员'],
                            subRouting: [
                                {
                                    path: 'new',
                                    name: '新建用户'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true,
                                    subRouting: [
                                        {
                                            path: 'evaInfo',
                                            name: '评估详情'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'nurse-manage',
                            name: '护理员管理',
                            inMenu: true,
                            appSubRole: ['测试', '管理员'],
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建护理员'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'appraiser-manage',
                            name: '评估师管理',
                            inMenu: true,
                            appSubRole: ['测试', '管理员'],
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建评估师'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'finance-manage',
                            name: '财务人员管理',
                            appSubRole: ['测试', '管理员'],
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'customer-service-manage',
                            name: '客服经理管理',
                            appSubRole: ['测试', '管理员'],
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'nurse-v2-manage',
                            name: '护士管理',
                            appSubRole: ['测试', '管理员'],
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'therapist-manage',
                            name: '康复师管理',
                            appSubRole: ['测试', '管理员'],
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'attendance',
                    name: '考勤管理',
                    notLink: true,
                    app: 'CAT',
                    appIconClass: 'fa-calendar',
                    subRouting: [
                        {
                            path: 'attendance-manage',
                            name: '护理员考勤',
                            appSubRole: ['测试', '管理员'],
                            inMenu: true
                        }
                    ]
                },
                // {
                //   path: 'data-statistics',
                //   name: '数据统计',
                //   notLink: true,
                //   app: 'CAT',
                //   appIconClass: 'fa-bar-chart-o',
                //   subRouting: [
                //     {
                //       path: 'single-statistics',
                //       name: '单量统计',
                //       inMenu: true,
                //       appSubRole: ['测试', '管理员'],
                //       subRouting: []
                //     },
                //     {
                //       path: 'order-status',
                //       name: '订单状态统计',
                //       inMenu: true,
                //       appSubRole: ['测试', '管理员'],
                //       subRouting: []
                //     },
                //     {
                //       path: 'income-analyse',
                //       name: '收入分析',
                //       inMenu: true,
                //       appSubRole: ['测试', '管理员'],
                //       subRouting: []
                //     },
                //     {
                //       path: 'new-channel-analyse',
                //       name: '新用户渠道分析',
                //       inMenu: true,
                //       appSubRole: ['测试', '管理员'],
                //       subRouting: []
                //     },
                //     {
                //       path: 'new-single-analyse',
                //       name: '新用户单量分析',
                //       inMenu: true,
                //       appSubRole: ['测试', '管理员'],
                //       subRouting: []
                //     }
                //   ]
                // },
                {
                    path: 'sms',
                    name: '提醒管理',
                    notLink: true,
                    app: 'CAT',
                    appIconClass: 'fa-phone-square',
                    subRouting: [
                        {
                            path: 'sms-manage',
                            name: '短信通知',
                            inMenu: true,
                            appSubRole: ['测试', '管理员'],
                            subRouting: []
                        }
                    ]
                },
                {
                    path: 'org-res-manage',
                    notLink: true,
                    name: '机构资源管理',
                    appIconClass: 'fa-object-group',
                    app: 'CAT',
                    subRouting: [
                        {
                            path: 'organization-info-v2',
                            name: '机构信息设置',
                            appSubRole: ['测试', '管理员'],
                            inMenu: true
                        },
                        {
                            path: 'info-component-v2',
                            name: '机构资讯管理',
                            appSubRole: ['测试', '管理员'],
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'article-manage-v2',
                            name: '机构宣教管理',
                            appSubRole: ['测试', '管理员'],
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'good-manage-v2',
                            name: '机构服务管理',
                            appSubRole: ['测试', '管理员'],
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'new',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '详情',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'content-manage-V2',
                            name: '机构内容展示',
                            appSubRole: ['测试', '管理员'],
                            inMenu: true
                        }
                    ]
                },
                {
                    path: 'family-team',
                    notLink: true,
                    name: '家医签约',
                    app: 'family-sign-manage',
                    appIconClass: 'fa-medkit',
                    subRouting: [
                        {
                            path: 'people-groups-manage',
                            name: '家医团队管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'service-packages-manage',
                            name: '服务包管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'sign-service-manage',
                            name: '签约管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'res-organization',
                    notLink: true,
                    name: '资源管理',
                    appIconClass: 'fa-object-group',
                    app: 'resource-management',
                    subRouting: [
                        {
                            path: 'organization-info',
                            name: '机构信息管理',
                            inMenu: true
                        },
                        {
                            path: 'article-manage',
                            name: '宣教管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'tool-manage',
                            name: '自测管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                }
                            ]
                        },
                        {
                            path: 'evaluation-manage',
                            name: '评估管理',
                            inMenu: true,
                            subRouting: []
                        },
                        {
                            path: 'notice-manage',
                            name: '机构公告管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'community-notice',
                            name: '社区公告管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'info-component',
                            name: '社区资讯管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'healthCare',
                    notLink: true,
                    name: '医护人员管理',
                    appIconClass: 'fa-ambulance',
                    app: 'medical-care',
                    subRouting: [
                        {
                            path: 'nurse-manage',
                            name: '医护人员管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                },
                                {
                                    path: 'service',
                                    name: '服务'
                                },
                                {
                                    path: 'record',
                                    name: '随访记录'
                                },
                                {
                                    path: 'followup',
                                    name: '随访管理',
                                    subRouting: [
                                        {
                                            path: 'add',
                                            name: '新建'
                                        }
                                    ]
                                },
                                {
                                    path: 'evaluation',
                                    name: '评估管理',
                                    subRouting: [
                                        {
                                            path: 'add',
                                            name: '新建'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: 'workLog-service',
                            name: '工作记录类型管理',
                            inMenu: true
                        }
                    ]
                },
                {
                    path: 'resident',
                    notLink: true,
                    name: '居民管理',
                    app: 'resident',
                    appIconClass: 'fa-users',
                    subRouting: [
                        {
                            path: 'resident-manage',
                            name: '居民列表',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                },
                                {
                                    path: 'in-file',
                                    name: '归档居民列表'
                                },
                                {
                                    path: 'batch-tags',
                                    name: '批量加标签'
                                },
                                {
                                    path: 'batch-followup',
                                    name: '创建随访'
                                },
                                {
                                    path: 'batch-evaluation',
                                    name: '创建评估'
                                },
                                {
                                    path: 'batch-article',
                                    name: '推送宣教'
                                },
                                {
                                    path: 'batch-tool',
                                    name: '推送自测'
                                }
                            ]
                        },
                        {
                            path: 'tag-manage',
                            name: '标签管理',
                            inMenu: true
                        },
                        {
                            path: 'follow-up-manage',
                            name: '随访管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'follow-up',
                                    name: '随访管理',
                                    notLink: true,
                                    subRouting: [
                                        {
                                            path: 'add',
                                            name: '新建'
                                        },
                                        {
                                            path: 'update',
                                            name: '编辑',
                                            notLink: true
                                        }
                                    ]
                                },
                                {
                                    path: 'care-path',
                                    name: '评估管理',
                                    notLink: true,
                                    subRouting: [
                                        {
                                            path: 'add',
                                            name: '新建'
                                        },
                                        {
                                            path: 'update',
                                            name: '编辑',
                                            notLink: true
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'electron',
                    notLink: true,
                    name: '转诊管理',
                    app: 'electron',
                    appIconClass: 'fa-hospital-o',
                    subRouting: [
                        {
                            path: 'referral-manage',
                            name: '转诊查询',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'update',
                                    name: '详情',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'org-in-out-manage',
                            name: '转入转出机构管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'update',
                                    name: '编辑',
                                    notLink: true
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'serving',
                    notLink: true,
                    name: '服务管理',
                    app: 'service-manage',
                    appIconClass: 'fa-fax',
                    subRouting: [
                        {
                            path: 'service-manage',
                            name: '服务设置',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'new',
                                    name: '新建'
                                },
                                {
                                    path: 'update',
                                    name: '详情',
                                    notLink: true
                                }
                            ]
                        },
                        {
                            path: 'reservation',
                            name: '预约管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'info',
                                    name: '详情',
                                    notLink: true
                                }
                            ]
                        }
                    ]
                },
                {
                    path: 'immunity',
                    notLink: true,
                    name: '计免管理',
                    app: 'planed-immunity',
                    appIconClass: 'fa-h-square',
                    subRouting: [
                        {
                            path: 'vaccine-manage',
                            name: '疫苗管理',
                            inMenu: true,
                        },
                        {
                            path: 'interval-manage',
                            name: '号源设置',
                            inMenu: true,
                        },
                        {
                            path: 'reserve-manage',
                            name: '预约查询',
                            inMenu: true,
                        }
                    ]
                },
                {
                    path: 'outpatient',
                    notLink: true,
                    name: '门诊管理',
                    app: 'outpatient',
                    appIconClass: 'fa-stethoscope',
                    subRouting: [
                        {
                            path: 'outpatient-manage',
                            name: '预约管理',
                            inMenu: true,
                        },
                        {
                            path: 'nurses-manage',
                            name: '人员设置',
                            inMenu: true,
                        }
                    ]
                },

                // 财务管理
                {
                    path: 'finance',
                    notLink: true,
                    name: '财务管理',
                    app: 'finance-app',
                    appIconClass: 'fa-stethoscope',
                    subRouting: [
                        {
                            path: 'gathering',
                            name: '财务记录',
                            inMenu: true,
                        },
                    ]
                },
                // 随访记录
                {
                    path: 'follow',
                    notLink: true,
                    name: '随访记录',
                    app: 'follow-up',
                    appIconClass: 'fa-stethoscope',
                    subRouting: [{
                        inMenu: true,
                        path: 'follow-up-record',
                        name: '随访列表',
                    }]
                },
                /* 图文咨询 */
                {
                    path: 'graphic-information',
                    notLink: true,
                    name: '图文咨询',
                    app: 'graphic-information',
                    appIconClass: 'fa-stethoscope',
                    subRouting: [
                        {
                            path: 'graphic-list',
                            name: '咨询列表',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'detail',
                                    name: '咨询详情'
                                },
                            ]
                        },
                    ]
                }, {
                    path: 'famous-doctors',
                    notLink: true,
                    name: '名护专栏',
                    app: 'famous-doctors',
                    appIconClass: 'fa-stethoscope',
                    subRouting: [
                        {
                            path: 'doctors-list',
                            name: '文章列表',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'doctors-detail',
                                    name: '医生详情'
                                }
                            ]
                        }
                    ]
                }, {
                    path: 'famous-studio',
                    notLink: true,
                    name: '名护工作室',
                    app: 'famous-studio',
                    appIconClass: 'fa-stethoscope',
                    subRouting: [
                        {
                            path: 'team-manage',
                            name: '团队管理',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'team-detail',
                                    name: '团队维护'
                                }
                            ]
                        }, {
                            path: 'disease-label',
                            name: '病种管理',
                            inMenu: true,
                        }
                    ]
                },
                /* 谣言粉碎机 */
                {
                    path: 'rumor',
                    notLink: true,
                    name: '谣言粉碎机',
                    app: 'rumor',
                    appIconClass: 'fa-stethoscope',
                    subRouting: [
                        {
                            path: 'rumor-index',
                            name: '谣言粉碎机列表',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'detail',
                                    name: '谣言百科维护'
                                },
                            ]
                        },
                    ]
                },
                // 礼品核销
                {
                    path: 'gift',
                    notLink: true,
                    name: '内部专用',
                    app: 'gift-verification',
                    appIconClass: 'fa-stethoscope',
                    subRouting: [
                        {
                            path: 'verification',
                            name: '礼品核销列表',
                            inMenu: true,
                        },
                        {
                            path: 'downLoad',
                            name: '推广下载',
                            inMenu: true,
                        }, {
                            path: 'appointment',
                            name: '参观预约',
                            inMenu: true,
                        }, {
                            path: 'appletsSetting',
                            name: '小程序配置',
                            inMenu: true,
                        }
                    ]
                },
                /* 家庭病床预约申请 */
                {
                    path: 'sick-bed',
                    notLink: true,
                    name: '家庭病床预约',
                    app: 'sick-bed',
                    appIconClass: 'fa-stethoscope',
                    subRouting: [
                        {
                            path: 'sick-bed-index',
                            name: '家庭病床预约申请',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'detail',
                                    name: '家庭病床预约申请详情'
                                },
                            ]
                        },
                    ]
                },
                /* 服务项目管理 */
                {
                    path: 'service-management',
                    notLink: true,
                    name: '服务项目管理',
                    app: 'service-management',
                    appIconClass: 'fa-stethoscope',
                    subRouting: [
                        {
                            path: 'project-application-index',
                            name: '服务项目管理首页',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '服务编辑'
                                },
                            ]
                        }
                    ]
                },


                /* 指导意见管理 */
                {
                    path: 'guidance-management',
                    notLink: true,
                    name: '指导意见管理',
                    app: 'guidance-management',
                    appIconClass: 'fa-stethoscope',
                    subRouting: [
                        {
                            path: 'guidance-single',
                            name: '指导单项列表',
                            inMenu: true,
                        },
                        {
                            path: 'guidance-wrap',
                            name: '指导意见组合',
                            inMenu: true,
                            subRouting: [
                                // {
                                //   path: 'add',
                                //   name: '服务编辑'
                                // },
                            ]
                        },
                        // {
                        //   path: 'guidance-demo',
                        //   name: '测试数据',
                        //   inMenu: true,
                        // },
                    ]
                },
                /* 在线缴费 */
                {
                    path: 'online-pay',
                    notLink: true,
                    name: '在线缴费',
                    app: 'online-pay',
                    appIconClass: 'fa-stethoscope',
                    subRouting: [
                        {
                            path: 'advance-payment-order',
                            name: '预交金订单列表',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'detail',
                                    name: '预交金订单详情'
                                },
                            ]
                        },
                    ]
                },
                /* 营养风险筛查 */
                {
                    path: 'nutrition',
                    notLink: true,
                    name: '营养筛查',
                    app: 'nutrition',
                    appIconClass: 'fa-stethoscope',
                    subRouting: [
                        {
                            path: 'nutrition-index',
                            name: '服务订单',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'detail',
                                    name: '筛查详情'
                                },
                            ]
                        }, {
                            path: 'nutrition-product',
                            name: '服务商品',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新增服务商品'
                                },
                            ]
                        }, {
                            path: 'nutrition-list',
                            name: '评估表',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'add',
                                    name: '新增评估表'
                                },
                            ]
                        }
                    ]
                },
                /* 优惠卷 */
                {
                    path: 'coupon',
                    notLink: true,
                    name: '优惠券',
                    app: 'coupon',
                    appIconClass: 'fa-stethoscope',
                    subRouting: [
                        {
                            path: 'coupon-list',
                            name: '优惠券列表',
                            inMenu: true,
                            subRouting: [
                                {
                                    path: 'detail',
                                    name: ''
                                },
                            ]
                        }, {
                            path: 'give-record',
                            name: '发放记录',
                            inMenu: true,
                        }
                    ]
                },
                /* 钱包账户余额 */
                {
                    path: 'account-balance',
                    notLink: true,
                    name: '账户余额管理',
                    app: 'account-balance',
                    appIconClass: 'fa-stethoscope',
                    subRouting: [{
                        inMenu: true,
                        path: 'account-list',
                        name: '账户列表',
                    }]
                },

                /* 患教手册 */
                // {
                //   path: 'education',
                //   notLink: true,
                //   name: '患教手册',
                //   // app: 'coupon',
                //   appIconClass: 'fa-stethoscope',
                //   subRouting: [
                //     {
                //       path: 'education-list',
                //       name: '手册列表',
                //       inMenu: true
                //     },
                //     {
                //       path: 'education-edit',
                //       name: '编辑手册',
                //       inMenu: false
                //     }, {
                //       path: 'education-add',
                //       name: '新增手册',
                //       inMenu: true
                //     }, {
                //       path: 'education-column',
                //       name: '栏目管理',
                //       inMenu: true
                //     }
                //   ]
                // }
            ]
        }
    ];

    private sideRoutingFilter(userInfo: any, routings: RoutingEntity, urlStack: Array<any>, result: Array<any>) {
        result = result || [];
        if (routings.subRouting) {
            for (const routing of routings.subRouting) {
                // mock demo
                if (environment.isMock && routing.app.indexOf('demo') >= 0) {
                    urlStack.push(routing.path);
                    if (routing.inMenu) {
                        result.push(
                            {
                                path: urlStack.join('/'),
                                name: routing.name,
                                app: routing.app,
                                appName: routing.appName,
                                iconClass: routing.iconClass || '',
                                appIconClass: routing.appIconClass || '',
                                appSubRole: routing.appSubRole || []
                            }
                        );
                    }
                    result = this.sideRoutingFilter(userInfo, routing, urlStack, result);
                    urlStack.pop();
                } else if (routing.authority && routing.authority !== userInfo.authority) {
                    continue;
                } else if (routing.app && userInfo.app.filter(app => app.appPath === routing.app).length === 0) {
                    continue;
                } else if (routing.role && userInfo.app.filter(app => app.appPath === routing.app)[0].role
                    .filter(role => routing.role === role.roleName).length === 0) {
                    continue;
                } else {
                    urlStack.push(routing.path);
                    if (routing.inMenu) {
                        result.push(
                            {
                                path: urlStack.join('/'),
                                name: routing.name,
                                app: routing.app,
                                appName: routing.appName,
                                iconClass: routing.iconClass || '',
                                appIconClass: routing.appIconClass || '',
                                sideColor: routing.sideColor || '',
                                appSubRole: routing.appSubRole || []
                            }
                        );
                    }
                    // if (routing.subRouting) {
                    //   for (let r of routing.subRouting) {
                    result = this.sideRoutingFilter(userInfo, routing, urlStack, result);
                    // }
                    // }
                    urlStack.pop();
                }
            }
        }
        return result;
    }

    private prefixRoutingMap(routing: RoutingEntity, isRoot?: boolean) {
        if (!isRoot) {
            routing.appName = routing.appName || routing.name;
            if (routing.appName === routing.name && routing.iconClass !== undefined) {
                routing.appIconClass = routing.iconClass;
            }
        }
        if (routing.subRouting) {
            for (const c of routing.subRouting) {
                if (routing.role) {
                    c.role = c.role || routing.role;
                }
                if (routing.app) {
                    c.app = c.app || routing.app;
                }
                if (routing.authority) {
                    c.authority = c.authority || routing.authority;
                }
                if (!isRoot) {
                    c.appName = c.appName || routing.appName;
                    c.appIconClass = c.appIconClass || routing.appIconClass;
                }
                this.prefixRoutingMap(c);
            }
        }
        return;
    }

    constructor(private userInfo: UserInfoService) {
        for (const routing of this.routingMap) {
            this.prefixRoutingMap(routing, true);
        }
    }

    getSideRouting(): Array<RoutingEntity> {
        let myRouting: Array<any> = [];
        const sideRouting: Array<any> = [];
        const roles = ['admin', 'nurse', 'user', 'demo'];
        for (const role of roles) {
            if (this.userInfo.userInfo[role + 'Info']) {
                myRouting = [...myRouting, ...this.sideRoutingFilter(this.userInfo.userInfo[role + 'Info'],
                    this.routingMap.filter(r => r.path === role)[0], [role], [])];
            }
            // if (environment.isMock && role === 'demo') {
            //   myRouting = [...myRouting, ...this.sideRoutingFilter('demo', this.routingMap.filter(r => r.path == role)[0], [role], [])];
            // }
            // April-test
            // if (!environment.isMock && role === 'april') {
            //   myRouting = [...myRouting, ...this.sideRoutingFilter('april', this.routingMap.filter(r => r.path == role)[0], [role], [])];
            // }
        }
        for (const r of myRouting) {
            if (sideRouting.filter(s => s.app === r.app && s.appName === r.appName).length !== 0) {
            } else {
                sideRouting.push({
                    app: r.app,
                    appName: r.appName,
                    appIconClass: r.appIconClass,
                    subRouting: []
                });
            }
            sideRouting.filter(s => s.app === r.app && s.appName === r.appName)[0].subRouting.push(r);
        }
        const filtedSideRouting = [];
        for (const r of sideRouting) {
            const filtedSubRouting = [];
            for (const sr of r.subRouting) {
                if (sr.appSubRole.length === 0) {
                    filtedSubRouting.push(sr);
                } else if (this.userInfo.checkWithAppAndRoleArray(r.app, sr.appSubRole)) {
                    filtedSubRouting.push(sr);
                }
            }
            if (filtedSubRouting.length > 0) {
                r.subRouting = filtedSubRouting;
                filtedSideRouting.push(r);
            }
        }
        return filtedSideRouting;
    }

    getHeadingRouting(url): Array<RoutingEntity> {
        url = url.split('?')[0];
        const urlArray = url.split('/');
        const headingRouting = [];
        const routingStack = [''];
        let routePointer = this.routingMap;
        urlArray.shift();
        for (const u of urlArray) {
            routingStack.push(u);
            let r = (routePointer || []).filter(router => router.path === u);
            r = r.length > 0 ? r : [{ name: u.split('?')[0], path: u.split('?')[0], notLink: true }];
            headingRouting.push(Object.assign(r[0] || {}, { url: routingStack.join('/') }));
            routePointer = r.length > 0 ? r[0].subRouting : [];
        }
        return headingRouting;
    }
}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/services/routing-center/routing-center.service.ts